<template>
  <div class="rate-template">
    <!-- 费率模板 -->
      <!-- <div class="title" >{{newAdd?'费率模板':'模板配置'}}</div> -->
      <!-- 返回列表 -->
      <!-- <div class="list-btn" @click="listBtnFun" v-show="!newAdd">返回列表</div> -->
    <el-row >
      <!-- 模板首页 -->
      <el-col :span="24" style="padding: 0 10px" >
        <el-card
          body-style="height: 90vh;padding:15px 20px"
          class="box-card devices-area"
          shadow="never"
        >
        <div class="top-search">
            <!-- 查询 -->
        <div :class="['search-box',{'search-foucs':inputFlag}]">
           <el-input placeholder="请输入名称" v-model.trim="tempName" class="input-with-select" @focus="focusFun" @blur="blurFun">
            <el-button slot="append" icon="el-icon-search" @click="searchFun"></el-button>
          </el-input>
        </div>
        <!-- 显示全部 -->
        <div class="hide-all">显示全部：<input type="checkbox" v-model="inputCheck"></div>
        <!-- 新增模板 -->
        <div class="add-template" @click="add_ed">新增</div>
        </div>

        <!-- <div class="mask" v-if="maskFlag">
          <div class="centent">
            <i class="el-icon-loading"></i>
           <div>数据加载中</div>
          </div>
        </div> -->
        
        <!-- 表格 -->
        <!-- v-show="!maskFlag" -->
          <table class="table mytable" border='1' >
              <thead style="">
                <tr class="table-primary">
                  <th scope="col" style="width:60px;">序号</th>
                  <th scope="col" style="width:300px;">计费名称</th>
                  <th scope="col" style="width:120px;">能源类型</th>
                  <th scope="col" style="width:120px;">单位</th>
                  <th scope="col" style="width:300px;">计费单价（元）</th>
                  <th scope="col" style="width:270px;">创建时间</th>
                  <th scope="col" style="width:120px;">状态</th>
                  <th scope="col" style="width:240px;">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!temDate || temDate.length ==0">
                    <td colspan="7">暂无数据</td>
                </tr>
                <tr v-for="(item,index) in temDate" :key="index">
                    <td>{{index +1}}</td>
                    <td>{{item.temName}}</td>
                    <td>{{item.energyType | energyType}}</td>
                    <td style="font-size:20px">{{item.energyType | company}}</td>
                    <td style="font-size:20px"> {{item.singleChargingStandard}}</td>
                    <td>{{item.createTime | date_format}}</td>
                    <td>
                         <el-switch v-model="item.dataStatus" @change="changeFun(item.dataStatus,item.id)" active-color="#52A1FF"></el-switch>
                    </td>
                    <td class="operate">
                            <div class="table-btn details" @click="edit_ed(index)">查看</div>
                            <span class="line"></span>
                            <div class="table-btn del" @click="delOpen(item.id)">删除</div>
                    </td>
                </tr>
                 
              </tbody>
          </table>
        
        
        </el-card>
      </el-col>
    </el-row>

     <!-- 新增修改 -->
    <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible"
      width="25%" center>
      <el-form :model="temp" :rules="rules" ref="temp" label-width="100px" class="demo-temp">
        <el-form-item label="计费名称:" prop="temName">
          <el-input v-model="temp.temName" :disabled="dialogStatus == 'edit'"></el-input>
        </el-form-item>
        <el-form-item label="能源类型:" prop="energyType">
            <el-select v-model="temp.energyType" placeholder="请选择" :disabled="dialogStatus == 'edit'">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
         <el-form-item label="计费单价:" prop="singleChargingStandard">
          <el-input v-model="temp.singleChargingStandard" :disabled="dialogStatus == 'edit'"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
      

  </div>
</template>
<script>
import {findSingleTemplateList,saveSingleBillingTemplate,singleBillingTempRemoveById,editEnableAndDisabled} from "../../../api/reading";

export default {
  data() {
    return {
         options: [{
          value: 'ELECTRIC',
          label: '电'
        }, {
          value: 'WATER',
          label: '水'
        }, {
          value: 'GAS',
          label: '气'
        }],
        maskFlag:true,//遮罩层
        value: '',
        detailsDisable:false, //查看详情禁用全部
        tempName:"",//搜索框
        inputFlag:false, //输入框样式
        //首页模板数据
        temDate:[],
        newListData:null, //筛选搜索关键字
        inputCheck:true, //查看全部复选框
        temp:{},//新增模板
        dialogVisible: false,//控制弹窗
        //控制输入框是否必填
         rules: {
          temName: [
            { required: true, message: '请输入计费名称', trigger: 'blur' }
          ],
          energyType: [
            { required: true, message: '请选择能源类型', trigger: 'blur' }
          ],
          singleChargingStandard: [
            { required: true, message: '请输入计费单价', trigger: 'blur' }
          ],

        },
          dialogStatus: '',//新增/编辑
        //切换新增编辑
         textMap: {
          add: "新增单价计费",
          edit: "查看单价计费详情"
        },
         
   }
 },
  created(){
    this.getList();//单价计费模板数据
  
  },
  methods:{
     //启用禁用状态改变
    changeFun(val,ids){
      let index =  this.temDate.findIndex(item => item.id == ids)
      let Tname = this.temDate[index].temName
      //true 启用 
      if(val){
        editEnableAndDisabled({choiceStatus:'ENABLE',id:ids}).then(data => {
            // console.log("启用",data);
            if(data.code ==200){
              this.operationFun('success',`${Tname} 启用成功`)     
            }else {
                this.operationFun('error',`${Tname} 启用失败`)     
            }
        })
      }else {
           editEnableAndDisabled({choiceStatus:'DISABLE',id:ids}).then(data => {
            if(data.code ==200){
                this.operationFun('warning',`${Tname} 已禁用!`)  
             }else {
                this.operationFun('error',`${Tname} 禁用失败`)     
            }
            // console.log("禁用",data);
        })
      }

    },
      // 转换启用禁用
    tranStatus(data){
            data.forEach(item => {
              if(item.dataStatus == 'ENABLE'){
                item.dataStatus = true
              }else {
                  item.dataStatus = false
              }
            })
    },

    //操作提醒
     operationFun(types,describe){

          this.$message({
             type: types,
             message: describe,

          });
    },
    // 获取单价计费模板数据
      getList(){
        findSingleTemplateList().then(data => {
          console.log("单价计费数据",data);
            this.temDate = data.data
            // this.maskFlag = false
             this.tranStatus(this.temDate)
           })
          //  .catch(() => {
          //        this.maskFlag = false
          //  })
      },
    //查询
    searchFun(){
      //判断输入框是否为空
      if(this.tempName == ''){
          this.operationFun('warning','输入框内容不能为空')     
          return;
      }
        this.inputCheck = false
        findSingleTemplateList({temName:this.tempName}).then(data => {
             console.log("搜索",data);
            this.temDate = data.data
            // console.log("查询",this.temDate);
            //转换启用跟禁用
              this.tranStatus(this.temDate)
           })
        
        
    },

    
    // 搜索框获得焦点
    focusFun(){
      this.inputFlag = true
    },
    // 搜索框失去焦点
    blurFun(){
        this.inputFlag = false
    },
    //新增单价计费
    add_ed(){
        this.temp = {}
        this.dialogStatus = 'add';
        this.dialogVisible = true;
    },
    //编辑单价计费
    edit_ed(index){
        this.dialogStatus = 'edit';
        this.dialogVisible = true;
        this.temp = this.temDate[index]
    },
     // 确认添加
      add_fn(formName) {
        this.$refs[formName].validate(valid => {

          if (valid) {
            saveSingleBillingTemplate(this.temp).then(data => {
              if (data.code == 200) {
                this.getList();
                this.dialogVisible = false;
                 this.$message({ showClose: true, message: '添加成功', type: 'success'});
              } else {
                  this.$message.success('添加失败');
              }
                       
            })

          } else {
            return false;
          }
        });
      },
      //  详情
      // detail_fn(v) {
      //   GitEnergyBuildingType(v).then(res=>{
      //     this.temp=res.Response
      //   })
      //   this.detail_status = true;
      // },
      // 确认编辑
      // edit_fn() {

      //   this.$refs['temp'].validate(valid => {
      //     if (valid) {
      //       saveSingleBillingTemplate(this.temp).then(data => {
      //         if (data.code ==200) {
      //           this.getList();
      //           this.dialogVisible = false;
      //           this.$message({ showClose: true, message: '修改成功', type: 'success'});
      //         } else {
      //           data.message ? this.$message.error(data.message) : this.$message.error('修改失败');
      //         }

      //       })
      //     } else {
      //       return false;
      //     }
      //   });
      // },
      // 确认编辑
      edit_fn() {
        this.$refs['temp'].validate(valid => {
          if (valid) {
               this.dialogVisible = false;
          } else {
            return false;
          }
        });
      },
    // 删除弹窗
      delOpen(id) {
        this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
  
                singleBillingTempRemoveById({"single_id":id}).then(data => {
                    if(data.code == 200){
                       this.getList();
                       this.operationFun('success','删除成功')
                    }
                    
                })
        }).catch(() => {
            this.operationFun('info','已取消删除')       
        });
      },
    //  delOpen(ids) {
    //     this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       let index = this.temDate.findIndex(item => item.id == ids)
    //        getRateRemoById({id:ids}).then(data => {
    //         //  console.log("删除操作",data);
    //           if(data.code == 200){
    //             this.temDate.splice(index,1)
    //             this.operationFun('success','删除成功')

    //           }else {
    //             this.operationFun('error','删除失败')
    //           }
               
    //        })
        
    //     }).catch(() => {
    //         this.operationFun('info','已取消删除')       
    //     });
    //   },

      

      // 查看详情
      viewDetailsFun(id){
        console.log("模板id",id);
        
      },


  },
  watch:{
     //显示全部
    inputCheck(val){
      if(val){
        this.tempName = ""
       this.getList();//单价计费模板数据
      }
    },
  },
  //过滤器
  filters:{
    //能源类型 ELECTRIC(电)  WATER(水) GAS(气)
    energyType(val){
      if(val == 'ELECTRIC'){
        return "电"
      }else if(val == 'WATER'){
        return "水"
      }else {
        return "气"
      }
    },
    //单位类型
      company(val){
      if(val == 'ELECTRIC'){
        return "kw·h"
      }else if(val == 'WATER'){
        return "t"
      }else {
        return "m³"
      }
    },
    // 转换时间戳
    "date_format":function (value) { //value就是插值的数据
      let date = new Date(value);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

      let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
      let strDate = Y + M + D + h + m + s;
       return strDate
    },
  }
};
</script>

<style lang="scss" scoped >

/deep/.el-input--suffix{
  display: flex;
  align-items: center;
  width: 350px;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
}
// /deep/.el-input__inner {
//    border-top:0px ;
// }
/deep/.el-dialog__body {
    padding: 25px 30px 30px 0px;
}

.rate-template 

   
      {
        position: relative;
        box-sizing:border-box;
        background-color: #edf2f9;
    

        
        //标题
        .title {
          height:25px;
          width:100px;
          color: #999;
          font-size: 18px;
          font-weight: 700;
          margin: 0px 0px 8px 0px;
          padding-left: 20px;
          padding-top: 5px;
        }
     
        .top-search {
          display: flex;
          align-items: center;
          .add-template {
            width: 88px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            color: #fff;
            background-color: #52A1FF;
            border-radius: 5px;
            cursor: pointer;
          }
          .hide-all {
            display: flex;
            align-items: center;
            margin: 0px 40px 0px 20px;
          }
        }
        // 查询
         /deep/.search-foucs .el-input__inner{
            background-color: #e4f1ff;
            color: #000;
            
          }
        .search-box { 
          .el-input {
            width: 350px;
          }
          /deep/.el-input__inner {
              height: 36px;
           
          }
          /deep/.el-input__inner:hover {
            border-color: #409eff;
          }
          /deep/.el-input-group__append {
            background-color: #409eff;
              color: #fff;
              font-size: 15px;
              border: 1px solid #409eff;
          }
        }
        .mask {
          position: absolute;
          top: 150px;
          left: 10px;
          width: 1700px;
          height: 600px;
          display: flex;
          justify-content: center;
          align-items: center;
            .centent {
              text-align: center;
            }
          i {
            font-size: 50px;
            color: #52A1FF;
            font-weight: 700;
            margin-bottom: 10px;
          }
        }
        //表格
        .mytable {
          border-collapse: collapse;
          margin-top: 30px;
          text-align: center;
          border: 1px solid #dcdfe6;
           thead {
                border-bottom:1px solid #dcdfe6;
            }
            .table-primary {
              background-color: #f3f8ff;
            }
            tr {
                height: 44px;
            }
           
              th {
                 border-left:1px solid #dcdfe6;
                 border-top:1px solid #dcdfe6;
                  font-size: 14px;
                  color: #909399;
                    text-align: center;

              }
           
          td {
            border-left:1px solid #dcdfe6;
             border-top:1px solid #dcdfe6;
             height: 44px;
             font-size: 16px;
               text-align: center;

          }
          .operate {
            display: flex;
            align-items: center;
            justify-content: center;
             .table-btn {
                height: 30px;
                line-height: 30px;
                color: #fff;
                cursor: pointer ;
                border-radius: 5px;
              }
              .line {
                width: 2px;
                height: 20px;
                background-color: #CCCCCC;
                margin: 0px 10px;
              }
                .details {
                  width: 88px;
                  background-color: #52A1FF;
                }
                .del {
                    width: 72px;
                   background-color: #FF8058;
                }
          }
          
          
        }


       
      }
</style>
